import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingOutlined } from '@ant-design/icons'

import CustomButton from '@/components/CustomButton'
import { useAppDispatch, useAppSelector } from '@/store/hook'
import { selectVoucherCode } from '@/store/selectors/cartSelector'
import { trackLinkName } from '@/store/slices/adobeAnalyticSlice'
import { LINK_NAMES } from '@/libs/constants/adobeAnalytics'
import { analyzeLinkName } from '@/libs/utils/adobeAnalysis'

import styles from './RedeemVoucherInput.module.scss'

interface RedeemVoucherInputProps {
  isRedeeming?: boolean
  isDisabled?: boolean
  handleRedeemVoucher: (voucherCode: string) => void
}

const RedeemVoucherInput = ({
  handleRedeemVoucher,
  isRedeeming = false,
  isDisabled = false,
}: RedeemVoucherInputProps) => {
  const { t } = useTranslation()
  const [voucherCode, setVoucherCode] = useState('')

  const voucherCodeFromStore = useAppSelector(selectVoucherCode)
  const dispatch = useAppDispatch()

  const handleClick = useCallback(
    (e) => {
      if (
        voucherCode
        && voucherCode !== ''
        && voucherCode !== voucherCodeFromStore
      ) {
        dispatch(trackLinkName(analyzeLinkName(LINK_NAMES.APPLY_VOUCHER)))
        handleRedeemVoucher(voucherCode)
        setVoucherCode('')
      }

      e.currentTarget.blur()
    },
    [dispatch, voucherCode, handleRedeemVoucher, voucherCodeFromStore],
  )

  return (
    <div className={styles.container}>
      <input
        className={styles.input}
        disabled={isDisabled}
        value={voucherCode}
        onChange={(e) => {
          setVoucherCode(e.target.value)
        }}
      />
      <div className={styles.redeem__button}>
        <CustomButton
          buttonSize="small"
          disabled={isRedeeming || isDisabled}
          type="ghost"
          onClick={handleClick}
        >
          {isRedeeming && <LoadingOutlined style={{ marginRight: 8 }} />}
          {t('redeemVoucher.applyVoucher')}
        </CustomButton>
      </div>
    </div>
  )
}

export default RedeemVoucherInput
